import { useEffect, useState } from "react";

const useWindowSize  = function () {

    const [windowSize, setWindowSize] = useState({
      width: document.body.clientWidth,
      height: window.innerHeight,
    });

    function checkSize() {
      setWindowSize({
        width: document.body.clientWidth,
        height: window.innerHeight,
      });
    }

    useEffect(() => {

      // Add event listener
      window.addEventListener("resize", checkSize);

      // Call handler right away so state gets updated with initial window size
      checkSize();

      // Extra check for safari madness
      setTimeout(() => {

        if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
          checkSize(); 
        }
  
      }, 500);

      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", checkSize);

    }, []);
    
    return {windowSize, checkSize};
  }

  export default useWindowSize